export const cubicBezier = 'cubic-bezier(0.35, 0, 0.25, 1)';
